<div class="project-timeline-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Project Delivery Flow</p>
      <h2>Timeline</h2>
      <p class="subtitle">Map project phases, task deadlines, and document milestones in one chronological stream.</p>
    </div>
    <div class="header-actions">
      <label class="project-picker">
        <span>Project</span>
        <select [(ngModel)]="selectedProjectId" (ngModelChange)="loadTimeline()">
          <option [ngValue]="null">Select project</option>
          <option *ngFor="let project of projects" [ngValue]="project.id">{{ project.name }}</option>
        </select>
      </label>
      <button mat-stroked-button (click)="loadProjects()">Refresh</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <ng-container *ngIf="selectedProject as project; else emptyState">
    <section class="summary-grid">
      <article class="summary-card lead">
        <span>Project Window</span>
        <strong>{{ project.startDate ? (project.startDate | date:'mediumDate') : 'Not set' }} to {{ project.endDate ? (project.endDate | date:'mediumDate') : 'Open-ended' }}</strong>
        <small>{{ timelineItems.length }} dated milestones available</small>
      </article>
      <article class="summary-card" *ngFor="let item of milestoneSummary">
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
      </article>
    </section>

    <section class="timeline-panel">
      <div class="panel-head">
        <h3>{{ project.name }} Timeline</h3>
        <span>{{ project.status || 'Active' }}</span>
      </div>

      <div class="timeline-stream" *ngIf="timelineItems.length; else noTimeline">
        <article class="timeline-card" *ngFor="let item of timelineItems">
          <div class="timeline-marker" [ngClass]="item.kind.toLowerCase()"></div>
          <div class="timeline-content">
            <div class="timeline-top">
              <span class="kind">{{ item.kind }}</span>
              <span class="status" [ngClass]="{ late: isLate(item.date, item.status), done: isDone(item.status) }">{{ item.status }}</span>
            </div>
            <h4>{{ item.title }}</h4>
            <p>{{ item.note }}</p>
            <div class="timeline-meta">
              <span>{{ item.date | date:'medium' }}</span>
              <span>{{ item.owner }}</span>
            </div>
          </div>
        </article>
      </div>
    </section>
  </ng-container>
</div>

<ng-template #emptyState>
  <section class="empty-state">
    <mat-icon>timeline</mat-icon>
    <h3>No project selected</h3>
    <p>Select a project to see its key dates, task due points, and document milestones.</p>
  </section>
</ng-template>

<ng-template #noTimeline>
  <div class="timeline-empty">
    <mat-icon>event_busy</mat-icon>
    <h3>No dated milestones yet</h3>
    <p>Add project dates, task deadlines, or onboarding items to build the delivery timeline.</p>
  </div>
</ng-template>
